import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import CountUp from "react-countup";
import {
  deleteSingleObject,
  deleteUser,
  getData,
} from "../../../Config/FirebaseMethod";

const FeedbackData = () => {
  const [PateintData, setPateintData] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [patientCount, setPatientCount] = useState(0);
  const [userID, setUserID] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [open, setOpen] = useState(false);
  let [list, setList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const PatientData = async () => {
    try {
      setisLoading(true);
      const res = await getData(`Feedback/`);

      setisLoading(false);
      setPateintData(res);

      const patientCount = res.length;
      setPatientCount(patientCount);
    } catch (err) {
      setisLoading(false);
      alert(err);
    }
  };

  let deleteItem = (id, listId) => {
    deleteSingleObject(`Feedback/${userID}`, listId);
    let listI = list.filter((value, index) => {
      return index !== id;
    });
    setList(listI);
    deleteSingleObject(`Feedback/${userID}`, listId)
      .then((res) => {
        setMsg(res);
        // window.location.reload(false);
        setOpen(true);
        setAlertSeverity("success");
        setAlertMessage("The Feedback Has Been Deleted Successfully");
      })
      .catch((err) => {
        setError(err);
        setAlertSeverity("error");
        setAlertMessage("The Feedback Has Not Deleted Please Try Again Later");
        setOpen(true);
      });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = PateintData.filter(
    (row) =>
      row.id.toLowerCase() === searchQuery.toLowerCase() ||
      row.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.suggestions.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedData = filteredData.slice(startIndex, endIndex);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the real-time function
        await PatientData();
      } catch (err) {
        // Handle any errors
        console.error(err);
      }
    };

    // Run the function initially
    fetchData();

    // Set up an interval to run the function periodically
    const interval = setInterval(fetchData, 2000); // Fetch data every 2 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Box>
                <Card sx={{ minWidth: 32 + "%", height: 150, borderRadius: 3 }}>
                  <Stack direction="row" spacing={40}>
                    <CardContent sx={{ padding: 5 }}>
                      <Typography gutterBottom variant="h5" component="div">
                        <CountUp
                          delay={0.2}
                          end={patientCount}
                          duration={0.3}
                        />
                      </Typography>
                      <Typography gutterBottom variant="body1" component="div">
                        Total Feedback
                      </Typography>
                    </CardContent>
                    <CardContent sx={{ padding: 5 }}>
                      <Typography gutterBottom variant="h3" component="div">
                        Feedback Data
                      </Typography>
                    </CardContent>
                  </Stack>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Paper>
                <Card
                  sx={{ minWidth: 32 + "%", height: "auto", borderRadius: 3 }}
                >
                  <Container className="mt-3 mb-5">
                    <TextField
                      id="outlined-basic"
                      label="Search"
                      variant="outlined"
                      sx={{ width: 300 }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                    <Box mt={7} />
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>S.ID</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Subject</TableCell>
                          <TableCell>Message</TableCell>
                          <TableCell>Category</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {displayedData.map((row, i) => (
                          <TableRow key={i}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.email}</TableCell>
                            <TableCell>{row.subject}</TableCell>
                            <TableCell>{row.suggestions}</TableCell>
                            <TableCell>{row.category}</TableCell>
                            <TableCell>
                              <button
                                className="btn btn-danger"
                                onClick={() => deleteItem(i, row.id)}
                              >
                                Delete
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <div className="conatiner mt-2">
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  </Container>
                </Card>
              </Paper>
            </Grid>
          </Grid>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
          >
            <Alert severity={alertSeverity} sx={{ width: "100%" }}>
              {alertMessage}
            </Alert>
          </Snackbar>
        </Box>
      )}
    </>
  );
};

export default FeedbackData;
